module.exports = __webpack_public_path__ + "static/media/icon-client-detail.9301da0e.svg";